<template>
  <v-card height="390px">
    <v-container class="div-preview">
      <pdf
        v-for="p in numPagesNotice"
        :key="'notice'+p"
        :src="noticeOfPrivacityUrl"
        :page="p"
        @loaded="noticeOfPrivacityLoaded = true"
      ></pdf>
      <pdf
        v-for="p in numPagesTerms"
        :key="'terms'+p"
        :src="termsAndConditionsUrl"
        :page="p"
        @loaded="termsAndConditionsLoaded = true"
      ></pdf>
      <p hidden>{{this.unnocuped}}</p>
    </v-container>
    <v-card-actions>
      <v-row justify="end">
        <v-checkbox
          ref="avisoPrivacidad"
          id="signup_agreements__acepto_aviso_privacidad__checkbox"
          class="mr-2"
          v-model="agreeAvisoPrivacidad"
          label="Acepto el aviso de privacidad"
        ></v-checkbox>
        <v-checkbox
          ref="condicionesServicio"
          id="signup_agreements__acepto_condiciones_servicio__checkbox"
          class="mr-2"
          v-model="agreeCondicionesServicio"
          label="Acepto las condiciones de servicio"
        ></v-checkbox>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import { signupActions, signupData } from '../store/signupWizardHelpers'
import { panelActions, pushNotification, resourceActions } from '@/store/helpers'

import pdf from 'vue-pdf'

export default {
  name: 'SignupAgreements',
  data() {
    return {
      noticeOfPrivacityLoaded: false,
      termsAndConditionsLoaded: false,
    }
  },
  components: {
    pdf,
  },
  created() {
    this.getFileNoticeOfPrivacy()
    this.getFileTermsAndConditions()
  },
  computed: {
    ...signupData,
    agreeAvisoPrivacidad: {
      get() {
        return this.avisoPrivacidad
      },
      set(value) {
        this.checkAvisoPrivacidad(value)
      }
    },
    agreeCondicionesServicio: {
      get() {
        return this.condicionesServicio
      },
      set(value) {
        this.checkCondicionesServicio(value)
      }
    },
    unnocuped: {
      get() {
        if(this.noticeOfPrivacityLoaded && this.termsAndConditionsLoaded){
          this.panelUnnocupied()
          return true
        }
        return false
      }
    }
  },
  methods: {
    ...signupActions,
    ...panelActions,
    ...resourceActions,
    getFileNoticeOfPrivacy(){
      this.panelBusy()
      this.noticeOfPrivacy()
      .then(result=>{
        let response = result.data
        if(response.successful.code=='RESOURCE-GET-200'){
          this.loadNoticeOfPrivacy(response.data)
        }else{
          this.noticeOfPrivacityLoaded = true
          this.messageError200(result)
        }
      })
      .catch(err=>{
        this.noticeOfPrivacityLoaded = true
        this.messageError400(err)
      })
    },
    getFileTermsAndConditions(){
      this.panelBusy()
      this.termsAndConditions()
      .then(result=>{
        let response = result.data
        if(response.successful.code=='RESOURCE-GET-200'){
          this.loadTermsAndConditions(response.data)
        }else{
          this.termsAndConditionsLoaded = true
          this.messageError200(result)
        }
      })
      .catch(err=>{
        this.termsAndConditionsLoaded = true
        this.messageError400(err)
      })
    },
    messageError200(result){
      try{
        this.messageError(result.data.successful.message)
      }catch{
        this.messageError()
      }
    },
    messageError400(err){
      try{
        this.messageError(err.response.data.successful.message)
      }catch{
        this.messageError()
      }
    },
    messageError(msg){
      pushNotification(
        this.$store,
        (msg || `No se pudo encontrar el recurso solicitado.`),
        'error',
        'left',
        false,
        false
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.iDocument {
  width: 99%;
}
.div-preview {
  overflow-y: scroll;
  max-height: 86%;
}
</style>